module.exports = __webpack_public_path__ + "static/media/bottom-fr.19c9b891.webp";